import Icon, { IconTypes } from '../../Icon';
import { gridImageSizes, mergeClassNames } from '../../../../utils';

import Image from '../../Image';
import PeopleAndSize from '../../../PeopleAndSize';
import React from 'react';
import RichText from '../../RichText';
import { isBuildTargetDevelop } from '../../../../utils/getBuildTarget';
import styles from './index.module.scss';

const ObjectFit = {
  contain: 'contain', // Devices
  cover: 'cover', // Workspaces
};

export { ObjectFit };

function getPerceptualBrightness(color) {
  let c = color.replace('#', '');
  var r = parseInt(c.substring(0, 2), 16);
  var g = parseInt(c.substring(2, 4), 16);
  var b = parseInt(c.substring(4, 6), 16);
  return r * 2 + g * 3 + b;
}

export default function GridItemStill({
  objectFit,
  objectPosition = '50% 50%',
  heading,
  description,
  backgroundColor = '#F2F4F5',
  image,
  numberOfSeats = null,
  physicalSizeM2 = null,
  children = null,
  gridSize = null,
  gridLayout = null,
  highlight = null,
  gridImagePad = false,
  availability = null,
}) {
  let showIconRow = Boolean(numberOfSeats) || Boolean(physicalSizeM2);

  return (
    <div
      className={mergeClassNames(
        styles.gridItemStill,
        showIconRow ? styles.showIconRow : '',
        styles[gridSize],
        styles[gridLayout]
      )}
      style={{ backgroundColor }}
    >
      <div className={mergeClassNames(styles.imageContainer, gridImagePad ? styles.padImage : '')}>
        <div className={styles.imageAnimation}>
          {image?.fluid && (
            <Image
              fluid={gridImageSizes(image.fluid)}
              className={styles.image}
              style={{ objectFit, objectPosition }}
              backgroundColor={backgroundColor}
              eager
              alt={image.description}
            />
          )}
        </div>
      </div>

      <div
        className={mergeClassNames(
          styles.contentContainer,
          getPerceptualBrightness(backgroundColor) < getPerceptualBrightness('#202020') && styles.inverted
        )}
      >
        <div className={styles.info}>
          <div className={styles.details}>
            {highlight ? (
              <label
                className={mergeClassNames(
                  styles.highlight,
                  getPerceptualBrightness(backgroundColor) < getPerceptualBrightness('#202020') && styles.invertedBorder
                )}
              >
                {highlight}
              </label>
            ) : null}
            <h5 className={styles.title}>{heading}</h5>
            {isBuildTargetDevelop() && availability && <div className={styles.availability}>{availability}</div>}
            <div className={styles.peopleAndSize}>
              <PeopleAndSize numberOfSeats={numberOfSeats} physicalSizeM2={physicalSizeM2} />
            </div>
            {description && <RichText className={styles.description}>{description}</RichText>}

            {children}
            <label className={styles.anchor}>
              <span>Learn More</span> <Icon className={styles.icon} IconType={IconTypes.rightWithLine}></Icon>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
